import { render, staticRenderFns } from "./CollectionCardSlider.vue?vue&type=template&id=1eddd2b3&scoped=true"
import script from "./CollectionCardSlider.vue?vue&type=script&lang=js"
export * from "./CollectionCardSlider.vue?vue&type=script&lang=js"
import style0 from "./CollectionCardSlider.vue?vue&type=style&index=0&id=1eddd2b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eddd2b3",
  null
  
)

export default component.exports